import React from 'react';
import useTranslation from 'hooks/use-translation';
import { SidebarFiltersSection } from 'components/sidebar-filters';
import useUI from 'hooks/use-ui';
import { useCategorySubcategoryFilter } from './use-category-subcategory-filter';
import { CategorySubcategories } from './types';
import { CategoriesList } from './categories-list';

export type CategorySubcategoryFilterProps = {
  categoriesSubcategories: CategorySubcategories[] | null;
};

export function CategorySubcategoryFilter({ categoriesSubcategories }: CategorySubcategoryFilterProps): JSX.Element {
  const { t } = useTranslation();
  const {
    selectedCategory,
    selectedSubcategories,
    handleClickCategory,
    handleClickSubcategory,
    handleClickSubcategoryMultiSelect,
  } = useCategorySubcategoryFilter();
  const { onCollectionsPage } = useUI();

  return (
    <SidebarFiltersSection collapsible={onCollectionsPage} heading={t('common.category_plural', 'Categories')}>
      <CategoriesList
        categoriesSubcategories={categoriesSubcategories}
        selectedCategory={selectedCategory}
        selectedSubcategories={selectedSubcategories}
        handleClickCategory={handleClickCategory}
        handleClickSubcategory={handleClickSubcategory}
        handleClickSubcategoryMultiSelect={handleClickSubcategoryMultiSelect}
      />
    </SidebarFiltersSection>
  );
}
